export default __webpack_public_path__ + "static/media/heart-icon.0b994e48.svg";